<template>
  <div class="loading-container" :class="containerClass">
    <div class="loading-spinner" :class="spinnerClass">
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
      <div class="spinner-ring"></div>
    </div>
    <p v-if="text" class="loading-text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    text: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value)
    },
    centered: {
      type: Boolean,
      default: true
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    containerClass() {
      return {
        'loading-centered': this.centered && !this.inline,
        'loading-inline': this.inline
      }
    },
    spinnerClass() {
      return `spinner-${this.size}`
    }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.loading-centered {
  justify-content: center;
  padding: 3rem 1rem;
}

.loading-inline {
  flex-direction: row;
  gap: 0.5rem;
  padding: 0;
}

.loading-spinner {
  position: relative;
}

.spinner-sm {
  width: 20px;
  height: 20px;
}

.spinner-md {
  width: 40px;
  height: 40px;
}

.spinner-lg {
  width: 60px;
  height: 60px;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #18181b;
  animation: spin 1s linear infinite;
}

.spinner-ring:nth-child(2) {
  border-top-color: #a1a1aa;
  animation-delay: 0.15s;
  opacity: 0.8;
}

.spinner-ring:nth-child(3) {
  border-top-color: #e4e4e7;
  animation-delay: 0.3s;
  opacity: 0.6;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin: 0;
  color: #71717a;
  font-size: 0.875rem;
  font-weight: 500;
}

.loading-inline .loading-text {
  font-size: 0.875rem;
}
</style>
